import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_Button, M_Fieldset, M_Header, M_MessageBoard, NavigateContext } from 'src/M_Components'
import { Refresh, Receipt } from '@mui/icons-material'

export const QuoteEquipmentDetailCrud = () => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [data, setData] = useState({})
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [leavingPage, setLeavingPage] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [editingId, setEditingId] = useState(null)

    const quoteDetailService = new BufferService('QuoteDetail')

    const sessionKeys = ['operation', 'data', 'open', 'passedRow', 'leavingPage']

    const matches15 = useMediaQuery('(min-width:615px)')
    const matches13 = useMediaQuery('(min-width:850px)')
    const matches10 = useMediaQuery('(min-width:1150px)')

    // ── Fields ────────────────────────────────────────────────────────────────

    const EquipmentFields = [
        {
            display: t('Equipment Type'),
            required: true,
            code: 'equipmentTypeCode',
            type: 'foreignKey',
            entity: 'EquipmentType',
            api: 'secondary',
            filterField: 'Code',
            labelFields: ['Code'],
            fields: [
                { key: 'Code',       value: 'equipmentTypeCode' },  
                { key: 'ExternalId', value: 'equipmentTypeId'   },  // obj.ExternalId (GUID) → data.equipmentTypeId (external Id porque vai buscar ao Container control)
            ],
            returnFunc: (data, field, obj) => {
                field.fields?.forEach(keyValue => {
                    changes(keyValue.value, obj && obj[keyValue.key] || '', setData)
                })
            }
        },
    ]

    const ChargeFields = [
        { display: t('Freight'),        required: true,  code: 'freight',       type: 'decimal' },
        { display: t('BAF'),                             code: 'baf',           type: 'decimal' },
        { display: t('ETS'),                             code: 'ets',           type: 'decimal' },
        { display: t('SES'),                             code: 'ses',           type: 'decimal' },
        { display: t('OOG'),                             code: 'oog',           type: 'decimal' },
        { display: t('THC'),                             code: 'thc',           type: 'decimal' },
        { display: t('BL'),                              code: 'bl',            type: 'decimal' },
        { display: t('ISPS'),                            code: 'isps',          type: 'decimal' },
        { display: t('Seal'),                            code: 'seal',          type: 'decimal' },
        { display: t('Other Fr. Surcharge'),             code: 'otFrSurchange', type: 'decimal' },
        { display: t('IMO Surcharge'),                   code: 'imoSurcharge',  type: 'decimal' },
        { display: t('CNCA'),                            code: 'cnca',          type: 'decimal' },
        { display: t('CNCA Printed'),                    code: 'cncaPrinted',   type: 'decimal' },
        { display: t('Dispatch'),                        code: 'dispatch',      type: 'decimal' },
    ]

    // ── Session storage ───────────────────────────────────────────────────────

    useEffect(() => {

        //what is this?
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))

            const editingQuoteDetail = JSON.parse(sessionStorage.getItem('editingQuoteDetail'))
            const operationType = sessionStorage.getItem('operationType')

            if (editingQuoteDetail && (operationType === 'Edit' || operationType === 'Copy')) {
                editOrCopyQuoteDetail(editingQuoteDetail.Id, operationType === 'Copy')
                sessionStorage.removeItem('editingQuoteDetail')
                sessionStorage.removeItem('operationType')
            } else if (operationType === 'Create') {
                setOperation('Create')
                sessionStorage.removeItem('operationType')
            }
        }
    // eslint-disable-next-line
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })


    // eslint-disable-next-line
    }, [id, operation, data, leavingPage])

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return  
        if (eval(value) instanceof String  && eval(value) === '') return                    
        if (eval(value) instanceof Number  && eval(value) === '') return                    
        if (eval(value) instanceof Map) {                                                   
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value)))) 
        } else {
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))             
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO  = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD  = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))
        const tempLP = JSON.parse(sessionStorage.getItem(`${sessionID}leavingPage`))

        if (
            (tempO && tempO !== '') ||
            (tempD && Object.keys(tempD).length !== 0) ||
            tempOS ||
            (tempPR && tempD && Object.keys(tempD).length !== 0)
        ) {
            setOperation(new String(tempO))
            setData(new Object(tempD))
            setOpen(tempOS)
            setPassedRow(tempPR)
            setLeavingPage(tempLP || false)
            ctx.setIsLoad(false)
            return
        }
        get()
    }

    const get = () => { ctx.setIsLoad(false) }

    // ── Actions ───────────────────────────────────────────────────────────────

    const refreshForm = () => {
        ctx.setIsLoad(true)
        sessionKeys.forEach(key => sessionStorage.removeItem(`${id}${key}`))
        setData({})
        setPassedRow({})
        setOpen(false)
        setOperation('')
        setLeavingPage(false)
        setIsEditMode(false)
        setEditingId(null)
        get()
        ctx.setIsLoad(false)
        ctx.toastMessages('success', t('Form refreshed'), '')
    }

    const onSave = () => {
        if (!data.equipmentTypeId || data.freight == null || data.freight === '') {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }

        const payload = {
            // QuoteId:           data.quoteId         || null,
            EquipmentTypeId:   data.equipmentTypeId || null,
            Freight:           parseFloat(data.freight)       || 0,
            BAF:               parseFloat(data.baf)           || 0,
            ETS:               parseFloat(data.ets)           || 0,
            SES:               parseFloat(data.ses)           || 0,
            OOG:               parseFloat(data.oog)           || 0,
            THC:               parseFloat(data.thc)           || 0,
            BL:                parseFloat(data.bl)            || 0,
            ISPS:              parseFloat(data.isps)          || 0,
            Seal:              parseFloat(data.seal)          || 0,
            OtFrSurchange:     parseFloat(data.otFrSurchange) || 0,
            ImoSurcharge:      parseFloat(data.imoSurcharge)  || 0,
            CNCA:              parseFloat(data.cnca)          || 0,
            CNCAPrinted:       parseFloat(data.cncaPrinted)   || 0,
            Dispatch:          parseFloat(data.dispatch)      || 0,
            DbStatus:          data.dbStatus || null,
        }

        ctx.setIsLoad(true)

        
        const savePromise = isEditMode && editingId
            ? quoteDetailService.update(editingId, payload)
            : quoteDetailService.post(payload)

        savePromise
            .then(response => {
                ctx.setIsLoad(false)
                if (response.name === 'AxiosError') { handleError(response); return }
                const msg = isEditMode
                    ? `${t('Quote Detail')} ${t('updatedSuccessfully')}`
                    : `${t('Quote Detail')} ${t('savedSuccessfully')}`
                ctx.toastMessages('success', '', msg)
                ctx2.closeTab(JSON.parse(id))
            })
            .catch(error => { ctx.setIsLoad(false); handleError(error) })
    }

    const editOrCopyQuoteDetail = (quoteDetailId, isCopy = false) => {
        ctx.setIsLoad(true)
        const timeout = setTimeout(() => ctx.setIsLoad(false), 10000)

        quoteDetailService.getId(quoteDetailId)
            .then(async response => {
                if (response.name === 'AxiosError') {
                    clearTimeout(timeout)
                    ctx.setIsLoad(false)
                    ctx.toastMessages('error', '', `${t('Quote Detail')} ${t('Failed to load')}`)
                    return
                }

                const detailData = {
                    // quoteId:           response.QuoteId?.toString(),
                    // quoteCode:         response.QuoteCode,          
                    equipmentTypeId:   response.EquipmentTypeId?.toString(),
                    equipmentTypeCode: response.EquipmentTypeCode,  
                    equipmentTypeName: response.EquipmentTypeName,  
                    freight:           response.Freight,
                    baf:               response.BAF,
                    ets:               response.ETS,
                    ses:               response.SES,
                    oog:               response.OOG,
                    thc:               response.THC,
                    bl:                response.BL,
                    isps:              response.ISPS,
                    seal:              response.Seal,
                    otFrSurchange:     response.OtFrSurchange,
                    imoSurcharge:      response.ImoSurcharge,
                    cnca:              response.CNCA,
                    cncaPrinted:       response.CNCAPrinted,
                    dispatch:          response.Dispatch,
                    dbStatus:          response.DbStatus,
                }

                await Promise.all([])

                if (isCopy) {
                    setIsEditMode(false)
                    setEditingId(null)
                    setOperation('Create')
                } else {
                    setIsEditMode(true)
                    setEditingId(quoteDetailId)
                    setOperation('Edit')
                }

                setData(detailData)
                clearTimeout(timeout)
                ctx.setIsLoad(false)
            })
            .catch(error => {
                clearTimeout(timeout)
                ctx.setIsLoad(false)
                console.error('Error loading quote detail:', error)
                ctx.toastMessages('error', '', `${t('Quote Detail')} ${t('Failed to load')}`)
            })
    }

    const handleError = (error) => {
        let errorMessage = `${t('Error saving')} ${t('Quote Detail')}`
        const errData = error.response?.data
        if (Array.isArray(errData)) {
            errorMessage = errData.map(e => `${e.field}: ${e.message}`).join('\n')
        } else if (errData?.errors) {
            errorMessage = Object.entries(errData.errors)
                .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                .join('; ')
        } else if (errData?.message) {
            errorMessage = errData.field ? `${errData.field}: ${errData.message}` : errData.message
        } else if (errData?.detail) {
            errorMessage = errData.detail
        } else if (errData?.title) {
            errorMessage = errData.title
        } else if (error.message) {
            errorMessage = error.message
        }
        ctx.toastMessages('error', '', errorMessage)
    }

    // ── Render ────────────────────────────────────────────────────────────────

    return (
        <div>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t('Back')}
                            label={t('Back')}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => setLeavingPage(true)}
                        />
                        <M_Button
                            tooltip={t('Refresh')}
                            icon={<Refresh />}
                            label={t('Refresh')}
                            onClick={() => refreshForm()}
                        />
                        <M_Button
                            tooltip={t('Save')}
                            icon={<i className="pi pi-save"></i>}
                            label={t('Save')}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />

            <div style={{ margin: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: !matches10 ? 'auto' : 'auto auto' }}>

                    {/* Quote + Equipment Type */}
                    <M_Fieldset
                        labelInside
                        label={
                            <div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}>
                                <Receipt style={{ marginRight: '10px', scale: '1.3' }} />
                                {t('Quote Equipment')}
                            </div>
                        }
                        elements={
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: !matches15 ? 'auto' : !matches13 ? 'auto auto' : 'auto auto auto',
                                justifyContent: 'space-evenly',
                            }}>
                                {EquipmentFields.map((field, index) =>
                                    fields(field, index, data, setData, null, field.returnFunc || null, '250px')
                                )}
                            </div>
                        }
                    />

                    {/* Charge values */}
                    <M_Fieldset
                        labelInside
                        label={
                            <div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}>
                                <i className="pi pi-dollar" style={{ marginRight: '10px', fontSize: '1.5rem' }}></i>
                                {t('Charges')}
                            </div>
                        }
                        elements={
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: !matches15 ? 'auto' : !matches13 ? 'auto auto' : 'auto auto auto',
                                justifyContent: 'space-evenly',
                            }}>
                                {ChargeFields.map((field, index) =>
                                    fields(field, index, data, setData, null, null, '250px')
                                )}
                            </div>
                        }
                    />

                </div>
                <div style={{ margin: '25px' }} />
            </div>

            <M_MessageBoard
                warning
                open={leavingPage}
                title={t('leavingPageTitle')}
                body={t('leavingPageBody')}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'}   onClick={() => setLeavingPage(false)}          label={t('ButtonCancel')}  />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => ctx2.closeTab(JSON.parse(id))} label={t('ButtonConfirm')} />
                    </span>
                }
            />
        </div>
    )
}